import LazyLoad from "vanilla-lazyload";

// Image lazy load
window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy'
});